import { WatchlistComponent } from './components/watchlist.component';
import { NwWatchlistRouting } from './watchlist.routes';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Http } from '@angular/http';
import { TranslateStore } from '@ngx-translate/core/src/translate.store';
import { INITIAL_WATCHLIST_APPLICATION_STATE } from './store/watchlist-state';
import { ActionReducer, StoreModule, combineReducers } from '@ngrx/store';
import { watchlistUiState } from './store/reducers/watchlistUiStateReducer';
import { watchlistStoreData } from './store/reducers/watchlistStoreDataReducer';
import { EffectsModule } from '@ngrx/effects';
import { VehiclesEffects } from './store/effects/VehiclesEffects';
import { VehiclesService } from './shared/services/vehicles.service';
import { VehicleNoteService } from './shared/services/vehicle-note.service';
import { VehicleSortService } from './shared/services/vehicle-sort.service';
import { VehicleFilterService } from './shared/services/vehicle-filter.service';
import { VehicleLiveblockAuctionService } from "./shared/services/vehicle-liveblock-auction.service";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NwSharedModule } from '@nw/ui-core-shared/shared.module';

import { WatchListActions } from './store/actions/WatchListActions';
import { WatchlistIotActions } from './store/actions/WatchlistIotActions';
import { IotHandlerService } from './shared/services/iot-handler.service';
import { TimerPipe } from './shared/pipes/timer.pipe';
import { NwDealerBlockModule } from '@nw/dealerblock-bid-ui/dealerblock.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
// import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';
// v1 pipes
import { ThumbnailImageUrlPipe } from './shared/pipes-v1/thumbnail_image_url.pipe';

import {
    VehicleListComponent,
    DropdownSortComponent,
    DropdownFilterComponent,
    SidebarComponent,
    VehicleRemoveComponent,
    LiveblockAuctionMobileViewComponent,

    VehicleListItemV1Component,
    VehicleInfoItemV1Component,
    VehicleNoteComponentV1,
    RunlistLiveblockItemV1Component,
    DealerblockItemV1Component,
    CountdownTimerV1Component,
    FirstTimeWlUserTutorialsV1Component
} from './components';

import { createTranslateLoader, MultiTranslateHttpLoader } from '@nw/ui-core-shared/utilities/translate';

import { TabsModule } from 'ngx-bootstrap/tabs';
import {HttpClientModule} from '@angular/common/http';
import {RemoveAllComponent} from './components/components-v1/remove-all-v1/remove-all.component';

const reducers = {
    watchlistUiState,
    watchlistStoreData
};

const reducer: ActionReducer<any> = combineReducers(reducers);

export function watchlistReducer(state: any = INITIAL_WATCHLIST_APPLICATION_STATE, action: any) {
    return reducer(state, action);
}

export function createWatchlistTranslateLoader(http: Http) {

    return new MultiTranslateHttpLoader(http, [
        {prefix: './assets/ui-watchlist/i18n/', suffix: '.json'},
        {prefix: './assets/dealerblock-bid-ui/i18n/', suffix: '.json'}
    ]);
}

@NgModule({
    declarations: [
        WatchlistComponent,
        VehicleListComponent,
        DropdownSortComponent,
        DropdownFilterComponent,
        SidebarComponent,
        VehicleRemoveComponent,
        TimerPipe,
        ThumbnailImageUrlPipe,
        LiveblockAuctionMobileViewComponent,

        VehicleListItemV1Component,
        VehicleInfoItemV1Component,
        VehicleNoteComponentV1,
        RunlistLiveblockItemV1Component,
        DealerblockItemV1Component,
        CountdownTimerV1Component,
        FirstTimeWlUserTutorialsV1Component,
        RemoveAllComponent
    ],
    imports     : [
        NwSharedModule,
        CommonModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        JsonpModule,
        TabsModule.forRoot(),
        NwWatchlistRouting,
        StoreModule.provideStore(watchlistReducer),
        EffectsModule.run(VehiclesEffects),
        StoreDevtoolsModule.instrumentOnlyWithExtension(),
        NwDealerBlockModule,
        AccordionModule.forRoot(),
        TranslateModule.forChild({
            loader : {
                provide   : TranslateLoader,
                useFactory: createWatchlistTranslateLoader,
                deps      : [Http]
            },
            isolate: true
        })
    ],
    providers: [
        VehiclesService,
        IotHandlerService,
        WatchListActions,
        WatchlistIotActions,
        VehicleNoteService,
        VehicleSortService,
        VehicleFilterService,
        TranslateStore,
        VehicleLiveblockAuctionService
    ]
})
export class NwWatchlistModule {
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/watchlist.module.ts